<template>
    <div class="flex flex-col items-center">
        <p class="text-200 mt-6 mb-6">
            {{ $t('§caf.reset_caf_form_paragraph-1') }}
        </p>
        <div v-if="showSaveFormButton" class="reset-form-modal__save-button mb-6">
            <CoreLinkPrimary
                text="§ui_button.save_calculation"
                iconName="arrow-right"
                :linkColorBlue="true"
                @click="handleSaveCalculation"
            />
        </div>
        <div class="flex justify-center gap-2">
            <CoreButton
                label="§ui_button.reset_calculation"
                variant="danger"
                @click="handleReset"
            />
            <CoreButton
                label="§ui_button.cancel"
                variant="tertiary"
                @click="handleClose"
                icon="pi-times"
            />
        </div>
    </div>
</template>

<script>
import { FORM_STATUS } from '@/stores/caf'
import { useModalStore } from '@/stores/modal'
import { useCafStore } from '@/stores/caf'
import CoreLinkPrimary from '@/components/core/CoreLinkPrimary.vue'
import CoreButton from '@/components/core/CoreButton.vue'

export default {
    name: 'ResetFormModal',

    components: { CoreLinkPrimary, CoreButton },

    data() {
        return {
            modalStore: useModalStore(),
            cafStore: useCafStore(),
        }
    },

    computed: {
        showSaveFormButton() {
            return this.cafStore.formStatus === FORM_STATUS.calculated
        },
    },

    methods: {
        handleReset() {
            this.cafStore.resetState()
            this.cafStore.applyFormDefaults(this.isWashtec())
            if (this.isWashtec()) {
                this.cafStore.sharedInputs.maintenance_cost_show_as = 'monthly_base_fee'
            }
            this.modalStore.setClose()
        },

        handleClose() {
            this.modalStore.setClose()
        },

        handleSaveCalculation() {
            // close first: setClose() would cancel the act-as-OEM confirm opened by the save
            this.modalStore.setClose()
            this.cafStore.saveContractWithConfirm()
        },
    },
}
</script>
